<div class="box-type-form core-screen">
  <div class="box-type-form__main-content">
    <p class="box-type-form__hint">
      {{ 'admin.boxTypes.create.nameAutoHint' | translate }}
    </p>

    <form [formGroup]="form" class="box-type-form__form">
      <div class="form-row">
        <lib-not-input
          type="text"
          inputmode="numeric"
          formControlName="side1Mm"
          [label]="'admin.boxTypes.create.side1Label' | translate"
          [required]="true"
          [placeholder]="'400' | translate"
          [error]="getFieldError('side1Mm') | translate"
          [height]="'56px'"
          mask="9999999999"
        />
        <lib-not-input
          type="text"
          inputmode="numeric"
          formControlName="side2Mm"
          [label]="'admin.boxTypes.create.side2Label' | translate"
          [required]="true"
          [placeholder]="'300' | translate"
          [error]="getFieldError('side2Mm') | translate"
          [height]="'56px'"
          mask="9999999999"
        />
      </div>

      <lib-not-input
        type="text"
        inputmode="numeric"
        formControlName="heightMm"
        [label]="'admin.boxTypes.create.heightMmLabel' | translate"
        [required]="true"
        [placeholder]="'300' | translate"
        [error]="getFieldError('heightMm') | translate"
        [height]="'56px'"
        mask="9999999999"
      />

      <lib-not-input
        type="textarea"
        formControlName="description"
        [label]="'admin.boxTypes.create.descriptionLabel' | translate"
        [placeholder]="'admin.boxTypes.create.descriptionPlaceholder' | translate"
        [error]="getFieldError('description') | translate"
        [height]="'120px'"
        [textAreaResizeAvailable]="false"
      />

      <div class="form-row">
        <lib-not-input
          type="text"
          inputmode="numeric"
          formControlName="layers"
          [label]="'admin.boxTypes.create.layersLabel' | translate"
          [required]="true"
          [placeholder]="'5' | translate"
          [error]="getFieldError('layers') | translate"
          [height]="'56px'"
          mask="99"
        />
        <lib-not-input
          type="text"
          inputmode="decimal"
          formControlName="maxWeightKg"
          [label]="'admin.boxTypes.create.maxWeightLabel' | translate"
          [required]="true"
          [placeholder]="'25' | translate"
          [error]="getFieldError('maxWeightKg') | translate"
          [height]="'56px'"
          mask="separator.2"
          [thousandSeparator]="''"
        />
      </div>
    </form>
  </div>

  <div class="box-type-form__actions">
    <lib-cabinet-button
      type="submit"
      variant="primary"
      size="lg"
      [fullWidth]="true"
      [disabled]="isSubmitting()"
      [isLoading]="isSubmitting()"
      [text]="'common.actions.create' | translate"
      [action]="{ type: 'action' }"
      (actionEvent)="onSubmit()"
    />
  </div>
</div>
